import {gql} from 'graphql-request';

const WEDDING_WEBSITE_QUERY = gql`
  query WeddingWebsite {
    weddingWebsite {
      registryNote
      state
      wwsUrl
    }
  }
`;

export default WEDDING_WEBSITE_QUERY;
